export default "__VITE_ASSET__FOCUJAri__"